import React, { useEffect, useState } from "react";

import I from "./Icon";

import BC from "./Breadcrumb";

import apiService from "../services/apiService";

const showNotification = (type, message) => {

  if (

    typeof document === "undefined" ||

    typeof window === "undefined"

  ) {

    return;

  }

  const existingNotification =

    document.getElementById(

      "center-form-notification"

    );

  if (existingNotification) {

    existingNotification.remove();

  }

  const notification =

    document.createElement("div");

  notification.id =

    "center-form-notification";

  notification.textContent =

    `${type === "success" ? "✓" : "✕"} ${message}`;

  Object.assign(

    notification.style,

    {

      position: "fixed",

      top: "20px",

      right: "20px",

      zIndex: "99999",

      minWidth: "280px",

      maxWidth: "420px",

      padding: "12px 16px",

      borderRadius: "8px",

      backgroundColor:

        type === "success"

          ? "#d1e7dd"

          : "#f8d7da",

      color:

        type === "success"

          ? "#0f5132"

          : "#842029",

      border:

        type === "success"

          ? "1px solid #badbcc"

          : "1px solid #f5c2c7",

      fontSize: "14px",

      fontWeight: "600",

      boxShadow:

        "0 4px 12px rgba(0,0,0,0.15)",

    }

  );

  document.body.appendChild(

    notification

  );

  window.setTimeout(() => {

    if (notification.parentNode) {

      notification.remove();

    }

  }, 3000);

};

const getApiErrorMessage = (

  error,

  fallback

) => {

  const data =

    error?.response?.data;

  if (

    typeof data === "string" &&

    data.trim()

  ) {

    return data;

  }

  if (

    data &&

    typeof data === "object"

  ) {

    if (

      data?.errors &&

      typeof data.errors === "object"

    ) {

      const validationErrors =

        Object.entries(data.errors)

          .flatMap(

            ([key, value]) => {

              const messages =

                Array.isArray(value)

                  ? value

                  : [value];

              return messages.map(

                (message) =>

                  `${key}: ${message}`

              );

            }

          )

          .filter(Boolean)

          .join(" ");

      if (validationErrors) {

        return validationErrors;

      }

    }

    return (

      data?.failureReason ||

      data?.FailureReason ||

      data?.message ||

      data?.Message ||

      data?.title ||

      data?.error ||

      error?.message ||

      fallback

    );

  }

  return (

    error?.message ||

    fallback

  );

};

export default function CenterForm({

  title,

  initial,

  onSave,

  onBack,

}) {

  const isEdit = !!initial;

  const [talukas, setTalukas] =

    useState([]);

  const [districts, setDistricts] = useState([]);

  const [

    capacities,

    setCapacities,

  ] = useState([]);

  const [loading, setLoading] =

    useState(true);

  const [saving, setSaving] =

    useState(false);

  const [error, setError] =

    useState("");

  const [fieldErrors, setFieldErrors] = useState({});

  const [f, setF] = useState({

    id: initial?.id || null,

    name: initial?.name || "",

    talukaId:

      initial?.talukaId || "",

    stateId: 1,

    districtId:

      initial?.districtId ?? 0,

    capacityId:

      initial?.capacityId || "",

    address:

      initial?.address || "",

    contact:

      initial?.contact || "",

    isActive: 1,

  });

  useEffect(() => {

    const fetchDropdownData = async () => {

      try {

        setLoading(true);

        setError("");

        const [

          districtRes,

          talukaRes,

          capacityRes,

        ] = await Promise.all([

          apiService.get(

            "DistrictMaster/getAllDistrictMasters?includeInActive=true"

          ),

          apiService.get(

            "TalukaMaster/getAllTalukaMasters"

          ),

          apiService.get(

            "Capacity/getAllCapacity"

          ),

        ]);

        const districtData = districtRes?.data;

        const talukaData = talukaRes?.data;

        const capacityData = capacityRes?.data;

        setDistricts(

          districtData?.output ??

          districtData?.Output ??

          []

        );

        setTalukas(

          talukaData?.output ??

          talukaData?.Output ??

          []

        );

        setCapacities(

          capacityData?.output ??

          capacityData?.Output ??

          []

        );

      } catch (err) {

        console.error(

          "Error loading dropdown data:",

          err

        );

        const message = getApiErrorMessage(

          err,

          "Unable to load dropdown data."

        );

        setError(message);

        showNotification("error", message);

      } finally {

        setLoading(false);

      }

    };

    fetchDropdownData();

  }, []);

  const s = (key, value) => {
    setF((prev) => ({
      ...prev,
      [key]: value,
    }));

    if (error) {
      setError("");
    }

    setFieldErrors((prev) => {
      const updated = { ...prev };
      delete updated[key];
      return updated;
    });
  };

  const validateForm = () => {
    const e = {};

    if (!f.name.trim()) e.name = "Center name is required";
    if (!f.districtId) e.districtId = "District is required";
    if (!f.talukaId) e.talukaId = "Taluka is required";
    if (!f.address.trim()) e.address = "Full address is required";
    if (!f.capacityId) e.capacityId = "Capacity is required";

    if (!f.contact.trim()) {
      e.contact = "Contact number is required";
    } else if (!/^\d{10}$/.test(f.contact)) {
      e.contact = "Contact number must be exactly 10 digits";
    }

    return e;
  };

  const handleSubmit = async () => {
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setFieldErrors(validationErrors);
      return;
    }

    setFieldErrors({});

    if (isEdit && !f.id) {
      const message = "Center ID is missing.";
      setError(message);
      showNotification("error", message);
      return;
    }

    const payload = {

        ...(isEdit && {

          id: Number(f.id),

        }),

        name:

          f.name.trim(),

        districtId:

          Number(

            f.districtId

          ) || 0,

        stateId: 1,

        talukaId:

          Number(

            f.talukaId

          ),

        capacityId:

          Number(

            f.capacityId

          ),

        address:

          f.address.trim(),

        contact:

          f.contact.trim(),

        isActive: 1,

      };

      try {

        setSaving(true);

        setError("");

        const response =

          isEdit

            ? await apiService.put(

              "Center/updateCenter",

              payload

            )

            : await apiService.post(

              "Center/addCenter",

              payload

            );

        const responseData = response?.data;

        const output = responseData?.output ?? responseData?.Output;

        const outputStatus = output?.status ?? output?.Status ?? "";

        const outputMessage = output?.message ?? output?.Message ?? "";

        const isSuccess = responseData?.isSuccess ?? responseData?.IsSuccess ?? true;

        const isDuplicate = String(outputStatus).toLowerCase().includes("duplicate");

        if (isDuplicate) {

          const duplicateMessage = outputMessage || "Center already exists.";

          setError(duplicateMessage);

          showNotification("error", duplicateMessage);

          return;

        }

        if (isSuccess === false) {

          const apiMessage =

            outputMessage ||

            responseData?.failureReason ||

            responseData?.FailureReason ||

            responseData?.message ||

            responseData?.Message ||

            (isEdit ? "Failed to update center." : "Failed to add center.");

          setError(apiMessage);

          showNotification("error", apiMessage);

          return;

        }

        const successMessage =

          outputMessage ||

          responseData?.message ||

          responseData?.Message ||

          (isEdit ? "Center updated successfully!" : "Center added successfully!");

        showNotification(

          "success",

          successMessage

        );

        if (onSave) {

          await onSave({

            ...payload,

            isEdit:

              isEdit,

            apiResponse:

              responseData,

          });

        }

      } catch (err) {

        console.error(

          "Center save error:",

          err

        );

        const message =

          getApiErrorMessage(

            err,

            isEdit

              ? "Unable to update center."

              : "Unable to add center."

          );

        setError(message);

        showNotification(

          "error",

          message

        );

      } finally {

        setSaving(false);

      }

    };

  const renderFieldError = (name) => {
    if (!fieldErrors?.[name]) return null;

    return (
      <div
        style={{
          color: "#dc2626",
          fontSize: 10.5,
          marginTop: 4,
        }}
      >
        {fieldErrors[name]}
      </div>
    );
  };

  if (loading) {

    return (

      <>

        <BC

          items={[

            "Centers",

            title,

          ]}

          onBack={onBack}

        />

        <div

          className="card cp"

          style={{

            maxWidth: 580,

            textAlign:

              "center",

            padding: 30,

          }}

        >

          Loading form...

        </div>

      </>

    );

  }

  return (

    <>

      <BC

        items={[

          "Centers",

          title,

        ]}

        onBack={onBack}

      />

      <div

        className="card cp"

        style={{

          maxWidth: 580,

        }}

      >

        <div

          style={{

            fontWeight: 700,

            fontSize: 15,

            marginBottom: 18,

          }}

        >

          {title}

        </div>

        <div className="fgrid">

          <div className="fg fall">

            <label className="fl">

              Center Name *

            </label>

            <input

              className="fi"

              value={f.name}

              onChange={(e) =>

                s(

                  "name",

                  e.target.value

                )

              }

              placeholder="Enter center name"

              disabled={saving}

            />
            {renderFieldError("name")}

          </div>

          <div className="fg">

            <label className="fl">

              State

            </label>

            <select

              className="fi"

              value={

                f.stateId

              }

              disabled

            >

              <option value="1">

                Maharashtra

              </option>

            </select>
            {renderFieldError("capacityId")}

          </div>

          <div className="fg">

            <label className="fl">

              District *

            </label>

            <select

              className="fi"

              value={f.districtId}

              onChange={(e) => {

                s("districtId", e.target.value);

                s("talukaId", "");

              }}

              disabled={saving}

            >

              <option value="">

                Select District

              </option>

              {districts

                .filter(

                  (d) =>

                    d.isActive ??

                    d.IsActive ??

                    true

                )

                .map((d) => (

                  <option

                    key={d.id ?? d.Id}

                    value={d.id ?? d.Id}

                  >

                    {d.districtName ??

                      d.DistrictName ??

                      d.name ??

                      d.Name}

                  </option>

                ))}

            </select>
            {renderFieldError("districtId")}

          </div>

          <div className="fg">

            <label className="fl">

              Taluka *

            </label>

            <select

              className="fi"

              value={f.talukaId}

              onChange={(e) =>

                s("talukaId", e.target.value)

              }

              disabled={saving || !f.districtId}

            >

              <option value="">

                Select Taluka

              </option>

              {talukas

                .filter((t) => {

                  const active =

                    t.isActive ??

                    t.IsActive;

                  const districtId =

                    t.districtId ??

                    t.DistrictId ??

                    t.district?.id ??

                    t.District?.Id;

                  return (

                    active &&

                    Number(districtId) ===

                    Number(f.districtId)

                  );

                })

                .map((t) => (

                  <option

                    key={t.id ?? t.Id}

                    value={t.id ?? t.Id}

                  >

                    {t.talukaName ??

                      t.TalukaName ??

                      t.name ??

                      t.Name}

                  </option>

                ))}

            </select>
            {renderFieldError("talukaId")}

          </div>

          <div className="fg fall">

            <label className="fl">

              Full Address

            </label>

            <input

              className="fi"

              value={

                f.address

              }

              onChange={(e) =>

                s(

                  "address",

                  e.target.value

                )

              }

              placeholder="Enter full address"

              disabled={saving}

            />
            {renderFieldError("address")}

          </div>

          <div className="fg">

            <label className="fl">

              Capacity *

            </label>

            <select

              className="fi"

              value={

                f.capacityId

              }

              onChange={(e) =>

                s(

                  "capacityId",

                  e.target.value

                )

              }

              disabled={saving}

 >

              <option value="">

                Select Capacity

              </option>

              {capacities

                .filter(

                  (c) =>

                    c.isActive

                )

                .map(

                  (c) => (

                    <option

                      key={

                        c.id

                      }

                      value={

                        c.id

                      }

                    >

                      {

                        c.name

                      }

                    </option>

                  )

                )}

            </select>

          </div>

          <div className="fg">

            <label className="fl">

              Contact

            </label>

            <input

              className="fi"

              value={f.contact}

              onChange={(e) => {

                const value = e.target.value

                  .replace(/\D/g, "")

                  .slice(0, 10);

                s("contact", value);

              }}

              placeholder="Enter 10 digit contact number"

              maxLength={10}

              inputMode="numeric"

              disabled={saving}

            />
            {renderFieldError("contact")}

          </div>

        </div>

        {error && (

          <div

            style={{

              marginTop: 15,

              color:

                "#dc2626",

              fontSize: 12,

            }}

          >

            {error}

          </div>

        )}

        <div

          style={{

            display: "flex",

            gap: 9,

            marginTop: 18,

          }}

        >

          <button

            className="btn btn-p"

            onClick={

              handleSubmit

            }

            disabled={saving}

          >

            <I

              n="check"

              s={13}

              c="#fff"

            />

            {saving

              ? "Saving..."

              : isEdit

                ? "Update"

                : "Add Center"}

          </button>

          <button

            className="btn btn-g"

            onClick={onBack}

            disabled={saving}

          >

            Cancel

          </button>

        </div>

      </div>

    </>

  );

}